/**
 * useCustomerCountry.js — customer's shipping country for cart currency display.
 */

import { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import {
  readStoredCustomerCurrencyContext,
  getCustomerCurrencyContextFromProfile,
  getCustomerCurrencyContextFromApiProfile,
} from '../utils/customerCountry';

const DEFAULT_CONTEXT = { countryCode: 'CA', countryName: '' };

export function useCustomerCountry() {
  return useCustomerCurrencyContext().countryCode;
}

export function useCustomerCurrencyContext() {
  const { currentUser } = useAuth();
  const [apiContext, setApiContext] = useState(null);

  useEffect(() => {
    let cancelled = false;

    async function load() {
      if (!currentUser) {
        if (!cancelled) setApiContext(null);
        return;
      }

      try {
        const token = localStorage.getItem('token');
        if (!token) return;

        const response = await fetch('/api/users/me', {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        });

        if (response.ok) {
          const profile = await response.json();
          const ctx = getCustomerCurrencyContextFromApiProfile(profile);
          if (!cancelled) setApiContext(ctx);
        }
      } catch {
        // Keep synchronous fallbacks
      }
    }

    load();
    return () => { cancelled = true; };
  }, [currentUser]);

  return (
    readStoredCustomerCurrencyContext()
    || getCustomerCurrencyContextFromProfile(currentUser?.username)
    || apiContext
    || DEFAULT_CONTEXT
  );
}
